<script setup>
</script>
<template>
  <div class="page-container new_article_design">
    <section class="blog-article-section">
      <article class="blog-article">
        <div class="container">
          <div class="single-article-wrapper">
            <div class="blog-post-date">October 21, 2024</div>
            <h1 class="article-title">
              Tools to power your trades and investments: October 2024
            </h1>
            <div class="article-cat">
              Blog |
              <a
                href="/market-talk/category/product-update/"
                rel="category tag"
                >PRODUCT UPDATE</a
              >
            </div>
            <div class="single-article-featured-img">
              <img
                width="1200"
                height="610"
                src="https://upstox.com/app/uploads/2024/10/image-47.png"
                class="secondary-thumbnail"
                alt=""
                loading="lazy"
                srcset="
                  https://upstox.com/app/uploads/2024/10/image-47.png          1200w,
                  https://upstox.com/app/uploads/2024/10/image-47-300x153.png   300w,
                  https://upstox.com/app/uploads/2024/10/image-47-1024x521.png 1024w,
                  https://upstox.com/app/uploads/2024/10/image-47-768x390.png   768w,
                  https://upstox.com/app/uploads/2024/10/image-47-50x25.png      50w
                "
                sizes="(max-width: 1200px) 100vw, 1200px"
              />
            </div>
            <div class="single-article-content">
              <p>
                <span style="font-weight: 400"
                  >Just like Diwali movie releases, we’ve also got some exciting
                  product releases for you this festive season.</span
                ><span style="font-weight: 400"><br /> </span
                ><span style="font-weight: 400"><br /> </span><b></b>
              </p>
              <p><b>💜 Major updates on ‘Upstox Pro for traders’</b></p>
              <p>&nbsp;</p>
              <p>
                <b>💸 Do more with less</b><b><br /> </b
                ><span style="font-weight: 400"
                  >Our margin products just got bigger, better bolder than
                  before</span
                ><span style="font-weight: 400"></span>
              </p>
              <p></p>
              <ul>
                <li style="font-weight: 400" aria-level="1">
                  <b>Margin Pledge</b><b><br /> </b
                  ><span style="font-weight: 400"
                    >Along with Stocks, ETFs, SGBs, you can now pledge </span
                  ><strong>Mutual Funds</strong>
                  <span style="font-weight: 400"
                    >to get up to 90% margin for F&amp;O buying and selling. You
                    can also use this margin for </span
                  ><strong>Intraday Equity orders starting in September</strong
                  ><b>.</b
                  ><span style="font-weight: 400">
                    This will be over and above the Exchange margin of 5X! Our
                    Margin Pledge facility is quick and easy – in just 15
                    minutes get funds for your pledged stocks.</span
                  ><span style="font-weight: 400"
                    ><p></p>
                    <p></p
                  ></span>
                </li>
                <li style="font-weight: 400" aria-level="1">
                  <b>Margin Trading Facility (MTF)</b><b><br /> </b
                  ><span style="font-weight: 400"
                    >Now get up to 75% funds to buy your favourite stocks and
                    hold them for a year via MTF. At a time you can get up to
                    ₹1.5 Crore funding via MTF!</span
                  ><span style="font-weight: 400"><br /> </span>
                </li>
              </ul>
              <p>&nbsp;</p>
              <p>
                <b>🆕 We’ve got more Ready-made Option Strategies </b
                ><b><br /> </b
                ><span style="font-weight: 400"
                  >Explore curated strategies for the following </span
                ><strong>new indices</strong
                ><span style="font-weight: 400">
                  for all trends: bullish, bearish, neutral and volatile</span
                ><span style="font-weight: 400"></span>
              </p>
              <p></p>
              <ul>
                <li style="font-weight: 400" aria-level="1">
                  <b>FINNIFTY</b><b><br /> </b
                  ><span style="font-weight: 400"
                    >This index tracks 20 stocks across the banking sector,
                    financial institutions, non-banking financial companies
                    (NBFCs), and housing finance firms.&nbsp;</span
                  >
                </li>
                <li style="font-weight: 400" aria-level="1">
                  <b>MIDCAP</b><b><br /> </b
                  ><span style="font-weight: 400"
                    >This index tracks the performance of 50 midcap stocks and
                    represents the mid-cap segment of the Indian stock
                    market.</span
                  >
                </li>
                <li style="font-weight: 400" aria-level="1">
                  <b>SENSEX</b> <span style="font-weight: 400"><br /> </span
                  ><span style="font-weight: 400">This index </span
                  ><span style="font-weight: 400"
                    >tracks 30 well-established and financially sound companies
                    listed on the Bombay Stock Exchange.</span
                  >
                </li>
              </ul>
              <p>&nbsp;</p>
              <p>
                <b>🫶 Significant other updates<br /> </b><b></b><b>⚡</b
                ><strong>Say hello to speed</strong
                ><span style="font-weight: 400"></span>
              </p>
              <p></p>
              <ul>
                <li style="font-weight: 400" aria-level="1">
                  <strong>40% faster API Orders:</strong>
                  <span style="font-weight: 400"
                    >Newly dedicated HFT endpoint offers blitz speed execution
                    of orders. Knock your opportunities faster than ever before
                    when you trade on the Upstox API platform.</span
                  ><span style="font-weight: 400"> <p></p></span>
                </li>
                <li style="font-weight: 400" aria-level="1">
                  <strong>New shortcuts:</strong
                  ><span style="font-weight: 400">
                    Head to the ‘Discover’ tab and find all asset classes
                    upfront. No more searching - find it all under one
                    section.</span
                  ><span style="font-weight: 400"> <p></p></span>
                </li>
              </ul>
              <p>&nbsp;</p>
              <p><b>💜 Major Updates on ‘Upstox Wealth’</b></p>
              <p>
                <span style="font-weight: 400"
                  >💪 Along with our Life Insurance, you can now buy Motor
                  insurance on Upstox.</span
                >
              </p>
              <p>&nbsp;</p>
              <p>
                <b>🫶 Significant other updates </b
                ><span style="font-weight: 400"><br /> </span
                ><span style="font-weight: 400"><br /> </span><b>⚡ </b
                ><strong>Say hello to easy discoverability</strong
                ><span style="font-weight: 400"><br /> </span>
              </p>
              <ul>
                <li style="font-weight: 400" aria-level="1">
                  <strong>Dynamic search feature:</strong
                  ><span style="font-weight: 400">
                    With this intuitive and interactive nav bar, searching for
                    Stocks and Mutual Fund is now easier than ever before!</span
                  ><span style="font-weight: 400"> <p></p></span>
                </li>
                <li style="font-weight: 400" aria-level="1">
                  <strong>NFOs aren’t out of sight anymore:</strong>
                  <span style="font-weight: 400"
                    >Our NFOs are now easily accessible from our ‘Explore More’
                    section</span
                  ><span style="font-weight: 400"> <p></p></span>
                </li>
              </ul>
              <p>&nbsp;</p>
              <p>
                <span style="font-weight: 400"
                  >That’s all folks! Hope these new features help you improve
                  your trading and investment journey. Our dev, product, design
                  teams have worked super hard to bring you these updates – if
                  you love them, don’t forget to share a review on Playstore and
                  App Store – it will make their day 🫶</span
                >
              </p>
            </div>
          </div>
        </div>
        <div class="download-App">
          <a
            href="https://bkafq.app.link/CjT31xOUosb"
            class="downApp-item"
            target="_blank"
          >
            <div class="app-icon">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/blog/apple-icon.png"
                alt="apple-icon"
              />
            </div>
            <div class="content-fold">
              <div class="text-logo">
                <span>Download</span>
                <div class="logoImg">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/blog/upstox-logo-primary.svg"
                    alt="logo"
                  />
                </div>
              </div>
              <h3>iOS App</h3>
            </div>
          </a>
          <a
            href="https://bkafq.app.link/CjT31xOUosb"
            class="downApp-item"
            target="_blank"
          >
            <div class="app-icon">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/blog/play-store-icon.png"
                alt="play-store"
              />
            </div>
            <div class="content-fold">
              <div class="text-logo">
                <span>Download</span>
                <div class="logoImg">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/blog/upstox-logo-primary.svg"
                    alt="logo"
                  />
                </div>
              </div>
              <h3>Android App</h3>
            </div>
          </a>
        </div>
      </article>
    </section>
  </div>
</template>
<style scoped>
</style>
